import { Drawer, IconButton, List, Box } from '@mui/material';
import TheGuarantorsLogo from '@/assets/images/updated-logo-white.png';
import { CloseOutlined, Menu } from '@mui/icons-material';
import { theme } from '@theguarantors/tg-package-material-ui';
import MenuContent from '@/appWrapper/MenuContent/V2';
import useMenu from '@/appWrapper/useMenu';

const MobileMenu = () => {
  const { menuOpen, openMenu, closeMenu } = useMenu();
  const themeAsAny = theme as any;

  return (
    <>
      <IconButton
        aria-label="open mobile menu drawer"
        edge="start"
        onClick={openMenu}
        sx={{ display: { xs: 'relative', md: 'none' } }}
      >
        <Menu fontSize="large" />
      </IconButton>
      <Drawer
        transitionDuration={300}
        variant="temporary"
        open={menuOpen}
        anchor="left"
        onClose={closeMenu}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        sx={{
          '& .MuiSvgIcon-root': { fill: 'white' },
          '& .MuiDrawer-paper': {
            boxSizing: 'border-box',
            width: '100%',
            backgroundColor: themeAsAny.palette.blue.main,
            color: 'white',
            borderRadius: 0,
          },
          display: { md: 'none' },
        }}
      >
        <Box sx={{ height: '100%' }}>
          <Box my={2} pb={2} mb={3} textAlign="center">
            <img height="24px" src={TheGuarantorsLogo} alt="TheGuarantors" />
          </Box>
          <Box sx={{ position: 'absolute', right: 'auto', top: '10px', left: '20px' }}>
            <IconButton aria-label="open mobile menu drawer" edge="start" onClick={closeMenu}>
              <CloseOutlined />
            </IconButton>
          </Box>

          <List sx={{ padding: 0, height: 'calc(100vh - 85px)' }}>
            <MenuContent menuOpen={true} />
          </List>
        </Box>
      </Drawer>
    </>
  );
};

export default MobileMenu;
